enum EanPrefixTypes {
  PRICE = 'PRICE',
  WEIGHT = 'WEIGHT',
  INTERNAL = 'INTERNAL',
  COUNTRYCODE = 'COUNTRYCODE',
}
export default EanPrefixTypes;
